import { withSchema } from '@websolutespa/bom-core';
import { Tabs as TabsBase } from './tabs';
import { TabsContent } from './tabs-content';
import { TabsContents } from './tabs-contents';
import { TabsGroup } from './tabs-group';
import { TabsTitle } from './tabs-title';

export const Tabs = withSchema(
  TabsBase,
  {
    Content: TabsContent,
    Contents: TabsContents,
    Group: TabsGroup,
    Title: TabsTitle,
  });

export type { TabsProps } from './tabs';
export type { TabsContentProps } from './tabs-content';
export type { TabsContentsProps } from './tabs-contents';
export type { TabsGroupProps } from './tabs-group';
export type { TabsTitleProps } from './tabs-title';

export * from './tabs.variants';

